import {
  ACTIVITIES_GET,
  ACTIVITY_GET,
} from './reduxConstant';

export const activitiesGet = (activities) => {
  
  return {
    type: ACTIVITIES_GET,
    payload: {
      activities,
    },
  };
};

export const activityGet = (activity) => {
  return {
    type: ACTIVITY_GET,
    payload: {
      activity,
    },
  };
};
